// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__SrNoF","spinner":"Spinner_spinner__EM4nX","spin":"Spinner_spin__zM8-M"};